import { useState } from 'react'
import { Token } from '@pancakeswap/sdk'
import { Flex, Text, ChevronUpIcon, ChevronDownIcon } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'
import styled from 'styled-components'
import PreviousBetsTable from './PreviousBetsTable'

interface MobileBetsTableProps {
  account: string
  token: Token
  api: string
}

const MobileBetsTable: React.FC<React.PropsWithChildren<MobileBetsTableProps>> = ({ account, token, api }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  const handleToggle = () => setIsOpen(!isOpen)

  return (
    <>
      <FlexContainer
        alignItems="center"
        justifyContent="space-between"
        // px="24px"
        // py="32px"
        // borderBottom="1px solid"
        // borderColor="cardBorder"
        style={{ cursor: 'pointer' }}
        onClick={handleToggle}
      >
        <Text className="label" as="h5" color="#FFFFFF" fontWeight="700" fontSize="14px">
          {t('Last %num% Bets', { num: 5 })}
        </Text>
        {!isOpen ? (
          <img alt="arr" src="/images/leaderboard/arr.svg" />
        ) : (
          <img alt="arr" style={{ transform: 'rotate(180deg)' }} src="/images/leaderboard/arr.svg" />
        )}
      </FlexContainer>
      {isOpen && <PreviousBetsTable account={account} token={token} api={api} />}

      {/* <Text
        style={{
          margin: '16px 0 8px 16px',
        }}
        as="h5"
        color="#FFFFFF"
        fontWeight="700"
        fontSize="14px"
      >
        {t('Last %num% Bets', { num: 5 })}
      </Text> */}

      {/* <PreviousBetsTable account={account} token={token} api={api} /> */}
    </>
  )
}

const FlexContainer = styled(Flex)`
  margin-right: 24px;
  .label {
    margin: 16px 0 8px 24px;
  }
  @media screen and (max-width: 700px) {
    .label {
      margin: 16px 0 8px 16px;
    }

    margin-right: 16px;
  }
`
export default MobileBetsTable
